/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Registration_Checkcodeerrordescription3Inputs */

const en_registration_checkcodeerrordescription3 = /** @type {(inputs: Registration_Checkcodeerrordescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please contact the person who shared the invitation. If you believe this is a mistake, contact support for assistance.`)
};

/**
* | output |
* | --- |
* | "Please contact the person who shared the invitation. If you believe this is a mistake, contact support for assistance." |
*
* @param {Registration_Checkcodeerrordescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const registration_checkcodeerrordescription3 = /** @type {((inputs?: Registration_Checkcodeerrordescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registration_Checkcodeerrordescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_registration_checkcodeerrordescription3(inputs)
});
export { registration_checkcodeerrordescription3 as "registration_checkCodeErrorDescription" }